import { adminApiGet, adminApiPatch, adminApiPost } from '../client';
import {
  AdminExpenseListResponseSchema,
  AdminExpenseResponseSchema,
  AdminPnlResponseSchema,
  type AdminExpense,
  type AdminPnl,
  type PlatformExpenseCategory,
} from '../schemas';

/** El Gasto de la plataforma y su P&L (services/api: admin-finance-routes.ts). */

export function listPlatformExpenses(): Promise<{ data: AdminExpense[] }> {
  return adminApiGet('/v1/admin/expenses', AdminExpenseListResponseSchema);
}

export type CreatePlatformExpenseInput = {
  concept: string;
  amountCents: number;
  category: PlatformExpenseCategory;
  incurredOn: string;
  isRecurringMonthly?: boolean;
  recurringUntil?: string;
};

export function createPlatformExpense(
  input: CreatePlatformExpenseInput,
  idempotencyKey: string,
): Promise<{ data: AdminExpense }> {
  return adminApiPost('/v1/admin/expenses', AdminExpenseResponseSchema, input, idempotencyKey);
}

/** Editar, Eliminar (`isActive: false`) y Terminar recurrencia son este patch. */
export type PatchPlatformExpenseInput = {
  concept?: string;
  amountCents?: number;
  category?: PlatformExpenseCategory;
  incurredOn?: string;
  isRecurringMonthly?: boolean;
  recurringUntil?: string | null;
  isActive?: boolean;
  /** The gasto's `version` as the list read it (docs/versiones-contra-choques.md); absent keeps the last write. */
  expectedVersion?: number;
};

export function patchPlatformExpense(
  expenseId: string,
  input: PatchPlatformExpenseInput,
): Promise<{ data: AdminExpense }> {
  return adminApiPatch(
    `/v1/admin/expenses/${encodeURIComponent(expenseId)}`,
    AdminExpenseResponseSchema,
    input,
  );
}

export function getPlatformPnl(from: string, to: string): Promise<{ data: AdminPnl }> {
  const query = `?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
  return adminApiGet(`/v1/admin/pnl${query}`, AdminPnlResponseSchema);
}
